import { useEffect, useState } from 'react';
import { getHotelCommunicationSettings } from '../services/api';

/** Loads hotel communication settings once on mount. */
export default function useHotelCommunicationSettings() {
  const [commSettings, setCommSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getHotelCommunicationSettings()
      .then((data) => {
        if (!cancelled) setCommSettings(data);
      })
      .catch(() => {
        if (!cancelled) setCommSettings(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { commSettings, loading };
}
